<div class="primary-bg p-v-6 text-align-justify" fxLayoutAlign="center start">
  <button (click)="location.back()" class="tint-white back" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="info-content p-6">
    <router-outlet />
  </div>
</div>
<recrewt-footer />
